var PES = PES || {};
PES.ImageCarouselSlider = function () {
    var clickOnBody = function () {
        $('body').on('click', function (e) {
            if ($(e.target)[0].className !== "circle-with-popup") {
                $('[data-toggle="popover"]').popover('hide');
            }
        });
    };

    var previewSlide = function () {
        $(".prev").on("click",
            function () {
                var firstActiveSlide = $('.page-area .slide-select.active').first();
                var prevSlideAfterActiveSlide = $('.page-area .slide-select.active').parent("li").prev();
                var index;
                if (prevSlideAfterActiveSlide.length > 0) {
                    prevSlideAfterActiveSlide.find("div").addClass("active");
                    firstActiveSlide.removeClass("active");
                } else {
                    firstActiveSlide.removeClass("active");
                    $('.slide-select').last().parent("li").find("div").addClass("active");
                }

                index = $('.page-area .slide-select.active').parent("li").attr("data-index");
                $(".slide-item").removeClass("active");
                $(".circle-with-popup-container").removeClass("show");
                $(".slide-item[data-index='" + index + "']").addClass("active");
                $(".circle-with-popup-container[data-index='" + index).addClass("show");

                showBanner();
            });   
    };


    var nextSlide = function () {
        $(".next").on("click",
            function () {
                var firstActiveSlide = $('.page-area .slide-select.active').first();
                var nextSlideAfterActiveSlide = $('.page-area .slide-select.active').parent("li").next();
                var index;
                if (nextSlideAfterActiveSlide.length > 0) {
                    nextSlideAfterActiveSlide.find("div").addClass("active");
                    firstActiveSlide.removeClass("active");
                } else {
                    firstActiveSlide.removeClass("active");
                    $('.page-area .slide-select').first().parent("li").find("div").addClass("active");
                }

                index = $('.page-area .slide-select.active').parent("li").attr("data-index");
                $(".slide-item").removeClass("active");
                $(".circle-with-popup-container").removeClass("show");
                $(".slide-item[data-index='" + index + "']").addClass("active");
                $(".circle-with-popup-container[data-index='" + index).addClass("show");

                showBanner();
            });
    };


    var changeSlide = function () {
        $(".slide-select").on("click",
            function () {
                if (!$(this).hasClass("active")) {
                    $(".slide-select").removeClass("active");
                    $(this).addClass("active");
                    const index = $(this).parent("li").attr("data-index");
                    $(".slide-item").removeClass("active");
                    $(".circle-with-popup-container").removeClass("show");
                    $(".slide-item[data-index='" + index + "']").addClass("active");
                    $(".circle-with-popup-container[data-index='" + index).addClass("show");
                }

                showBanner();
            });
    };

    var showBanner = function () {
        var hasRibbon = '.image-area .slide-container .slide-item.has-ribbon';
        var ribbonContainer = '.right-area > .row.row__banner';

        if ($(hasRibbon).hasClass('active')) {
            $(ribbonContainer).addClass('active');
        } else {
            $(ribbonContainer).removeClass('active');
        }
    };


    var addPulsingElements = function () {
        var pulsingOrigin = $('.slider-with-circles > .circle-with-popup');
        var pulseElements = '<i class="pulse-circle pulse-circle-inner"></i><i class="pulse-circle pulse-circle-outer"></i>';

        $(pulsingOrigin).each(function () {
            $(this).append(pulseElements);
        });
    };

    var init = function () {
        clickOnBody();
        changeSlide();
        previewSlide();
        nextSlide();
        showBanner();
        addPulsingElements();
    };

    return {
        init: init
    };
}();